import { render, staticRenderFns } from "./BotaoLaudos.vue?vue&type=template&id=3c4d0a23&lang=pug"
import script from "./BotaoLaudos.vue?vue&type=script&lang=js"
export * from "./BotaoLaudos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports